// ContactOne component - Placeholder
import React from 'react';
import GetQuote from './GetQuote.jsx';

const ContactOne = () => {
  return <GetQuote />;
};

export default ContactOne;
